export interface MachineLogicConfiguration {
  pythonDocumentationUrl: string;
}

let _machineLogicConfiguration: MachineLogicConfiguration;

export function getMachineLogicConfiguration(): MachineLogicConfiguration {
  return _machineLogicConfiguration;
}

export function setMachineLogicConfiguration(machineLogicConfiguration: MachineLogicConfiguration): void {
  _machineLogicConfiguration = machineLogicConfiguration;
}